import Axios from "axios";
import ApiUtils from "../utils/api_utils";

const RedeemSM = {
  state: 0,
  reducers: {},
  effects: () => ({
    /**
     * redeemtion type promo code
     */
    async redemptionPromoCode(payload, rootState) {
      await Axios.post(
        `https://${ApiUtils.authority}/redemptions/api/redemptions/`,
        payload,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function () {})
        .catch(function () {});
    },

    /**
     * redeemtion type flash password
     */
    async redemptionFlashPassword(payload, rootState) {
      await Axios.post(
        `https://${ApiUtils.authority}/redemptions/admin/redemption_options/flash_password`,
        payload,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function () {})
        .catch(function () {});
    },

    /**
     * redeemtion type upload photo
     */
    async redemptionUploadPhoto(payload, rootState) {
      await Axios.post(
        `https://${ApiUtils.authority}/redemptions/admin/redemption_options/flash_password`,
        payload,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function () {})
        .catch(function () {});
    },

    /**
     * redeem voucher
     */
    async redemptionVoucher(payload, rootState) {
      let result;
      await Axios.post(
        `https://${ApiUtils.authority}/redemptions/api/redemptions/`,
        payload,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then((response) => {
          console.log("response zzz", response);
          result = {
            status: 200,
            message: response.data.description,
            responseFull: response.data,
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    /**
     * use voucher
     */
    async useVoucher(payload, rootState) {
      let result;
      await Axios.post(
        `https://${ApiUtils.authority}/wallet/api/use_voucher/`,
        payload,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(() => {
          result = {
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    /**
     * redeem inquiry
     */
    async redemptionInquiry(payload, rootState) {
      let result;
      await Axios.post(
        `https://${ApiUtils.authority}/redemptions/api/redemptions/inquiry/`,
        payload,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then((response) => {
          result = {
            status: 200,
            message: "success",
            data: response.data,
          };
        })
        .catch((error) => {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    /**
     * redeem dana
     */
    async redemptionDana(payload, rootState) {
      let result;
      await Axios.post(
        `https://${ApiUtils.authority}/redemptions/api/redemptions/`,
        payload,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then((response) => {
          console.log("response", response);
          result = {
            status: 200,
            message: "success",
            responseFull: response.data,
          };
        })
        .catch((error) => {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
  }),
};

export default RedeemSM;
